import { createMachine } from 'xstate'

export const STATES = {
  LOAD_SUCCESS: 'LOAD_SUCCESS',
  CREATING: 'CREATING',
  CREATE_ERROR: 'CREATE_ERROR',
  CREATE_SUCCESS: 'CREATE_SUCCESS',
}

export const TRANSITIONS = {
  onCreate: 'onCreate',
  onCreateError: 'onCreateError',
  onCreateSuccess: 'onCreateSuccess',
}

export default createMachine({
  id: 'cottageContactDealPageForm',
  initial: STATES.LOAD_SUCCESS,
  states: {
    [STATES.LOAD_SUCCESS]: {
      on: {
        [TRANSITIONS.onCreate]: STATES.CREATING,
      },
    },
    [STATES.CREATING]: {
      on: {
        [TRANSITIONS.onCreateError]: STATES.CREATE_ERROR,
        [TRANSITIONS.onCreateSuccess]: STATES.CREATE_SUCCESS,
      },
    },
    [STATES.CREATE_ERROR]: {
      on: { [TRANSITIONS.onCreate]: STATES.CREATING },
    },
    [STATES.CREATE_SUCCESS]: {
      type: 'final',
    },
  },
  predictableActionArguments: true,
})
